import React from "react";
import { useParams } from "react-router-dom";
import PageLayout from "../../public/pages/PageLayout";

/**
 * Layout for custom roles (not in ROLE_SHELL_ROUTES).
 * Sidebar menu is loaded from permissions via PageLayout + roleSlug.
 */
export default function DynamicRoleShellLayout() {
  const { roleSlug } = useParams();
  return (
    <PageLayout
      requiredRoleSlug={roleSlug}
      logoutPath="/user-login"
      useDynamicNav
    />
  );
}
